import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import { useOffline } from "../lib/offline-context.js";
import type { SyncError } from "../lib/offline-context.js";

function formatReason(t: TFunction, e: SyncError): string {
  if (e.status === "conflict") return t("sync.error.conflictReason", { reason: e.reason });
  return e.reason || t("sync.error.defaultReason");
}

export function SyncErrorToasts() {
  const { t } = useTranslation();
  const { syncErrors, dismissSyncError } = useOffline();
  if (syncErrors.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {syncErrors.map((e) => (
        <div
          key={e.id}
          role="alert"
          className="rounded-md border border-red-300 bg-red-50 text-red-900 shadow-md px-3 py-2 text-sm"
        >
          <div className="flex items-start gap-2">
            <div className="flex-1 min-w-0">
              <div className="font-medium">
                {t("sync.error.title", { kind: t(`sync.mutationKind.${e.kind}`) })}
              </div>
              <div className="text-xs mt-0.5 break-words">{formatReason(t, e)}</div>
            </div>
            <button
              onClick={() => dismissSyncError(e.id)}
              className="text-red-700 hover:text-red-900 text-xs px-1"
              aria-label={t("common.close")}
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
